import { render, staticRenderFns } from "./BlogCarousel.vue?vue&type=template&id=714a68e8"
import script from "./BlogCarousel.vue?vue&type=script&lang=js"
export * from "./BlogCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports